<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-titlepage title-page" epub:type="titlepage" id="title-page">
<div class="title-page-title-subtitle-block">
<h1 class="title-page-title">Trail Marked</h1>
<h2 class="title-page-subtitle">Keeper of Magic Series Book 1</h2>
</div>
<div class="title-page-contributor-block">
<div class="title-page-contributor-primary-block">
<h2 class="title-page-contributor title-page-contributor-primary title-page-contributor-without-introduction"><span class="title-page-contributor-name">Heather Hambel Curley</span></h2>
<h2 class="title-page-contributor title-page-contributor-primary title-page-contributor-without-introduction"><span class="title-page-contributor-name">Rebecca Hamilton</span></h2>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title-page.vue?6d2221fe